import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SfzDialogComponent } from 'app/shared/sfz-dialog/sfz-dialog.component';
import { AuthenticationService } from 'app/core/security/authentication-service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DialogValidarExtratoComponent } from './dialog-validar-extrato/dialog-validar-extrato.component';
import { ExtratoService } from './extrato.service';
import { Extrato } from 'app/shared/model/extrato.model';

@Component({
  selector: 'app-validar-extrato',
  templateUrl: './validar-extrato.component.html',
  styleUrls: ['./validar-extrato.component.scss']
})
export class ValidarExtratoComponent {

  modalRef?: NgbModalRef;
  numeroExtratoControl = new FormControl('');

  constructor(
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private extratoService: ExtratoService
  ) { }

  limpar(): void {
    this.numeroExtratoControl.reset();
  }

  get numeroExtratoPreenchido(): boolean {
    return !!this.numeroExtratoControl.value?.toString().trim();
  }

  consultar(): void {
    if(!AuthenticationService.temPermissaoParaExibirValidarExtratoProcessamentoEFD("Você não tem permissão para validar o extrato.")) {
      return;
    }

    const parametros = { numeroExtrato: this.numeroExtratoControl.value };

    this.spinner.show();

    this.extratoService.validar(parametros)
      .pipe(
        finalize((): void => {
          this.spinner.hide()
        })
      )
      .subscribe({
        next: (data) => {
          this.abrirModal(data);
        },
        error: (err) => {
          this.spinner.hide();
          if (err.status === 403) {
            this.openDialog("Permissão negada", err.error.titulo, err.error.detalhe)
          } else if (err.status === 404) {
            this.abrirModal(err.error as Extrato);
          } else {
            this.toastr.error(err?.error?.detail || err?.error?.message || err?.message ||
              'Ocorreu um erro ao validar o extrato', 'Erro');
          }
        }
      });
  }

  abrirModal(extrato: Extrato): void {
      const modalRef = this.modalService.open(DialogValidarExtratoComponent, { size: 'lg' });
      modalRef.componentInstance.extrato = extrato;
  }

  private openDialog(titulo: string, mensagem: string, detalhe: string): void {
    this.dialog.open(SfzDialogComponent, {
      data: { titulo, mensagem, detalhe }
    });
  }

}
